import React, { useState } from 'react';
import styled from 'styled-components';

import messages from './messages';

import { FormattedMessage } from 'react-intl';
import CookieBanner from 'react-cookie-banner';
import logo from 'images/RR_Logo_Lsp2.svg';
import Button from 'components/forms/Button';
import Checkbox from 'components/forms/Checkbox';

export const PRIVACY_POLICY_URL =
    'https://static1.squarespace.com/static/630fc7533f33622148b290ef/t/673e2553634f0235c972c746/1732126035908/RR-+Privacy+Policy++.pdf';
export const TERMS_OF_USE_URL =
    'https://static1.squarespace.com/static/630fc7533f33622148b290ef/t/673daf432976535c7b3a7214/1732095812214/RR+Terms+of+Use+-+Nov+2021+.pdf';
export const COOKIES_NAME = 'accepts-cookies-v2';

const MaskedBackground = styled.div`
    display: flex;
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    justify-content: center;
    align-items: center;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 630px;
    padding: 20px;
    background-color: white;
    font-family: ${({ theme }) => theme.font.regular};
    text-align: center;

    & > div {
        margin-bottom: 15px;
    }
`;

const Link = styled.a`
    text-decoration: underline;
    font-weight: bold;
    color: ${({ theme }) => theme.text};
`;

const PrivacyPolicyModal = () => {
    const [accepted, setAccepted] = useState(false);
    const onClickCheckbox = (event) => {
        setAccepted(event.target.checked);
    };
    return (
        <CookieBanner cookie={COOKIES_NAME} cookieExpiration={{ years: 100 }}>
            {(onAccept) => (
                <MaskedBackground>
                    <Container>
                        <img alt="logo" src={logo} />
                        <FormattedMessage {...messages.cookiesTerm} tagName="div" />
                        <div>
                            <Link href={PRIVACY_POLICY_URL} rel="noopener noreferrer" target="_blank">
                                <FormattedMessage {...messages.linkToCookies} />
                            </Link>
                        </div>
                        <div>
                            <Checkbox checked={accepted} onChange={onClickCheckbox}>
                                <FormattedMessage
                                    {...messages.termsOfUse}
                                    values={{
                                        link: (chunks) => (
                                            <Link href={TERMS_OF_USE_URL} rel="noopener noreferrer" target="_blank">
                                                {chunks}
                                            </Link>
                                        ),
                                    }}
                                />
                            </Checkbox>
                        </div>
                        <div>
                            <Button type="primary" size="large" onClick={onAccept} disabled={!accepted}>
                                <FormattedMessage {...messages.acceptButton} />
                            </Button>
                        </div>
                    </Container>
                </MaskedBackground>
            )}
        </CookieBanner>
    );
};

export default PrivacyPolicyModal;
